import {
  overwriteGetLocale,
  overwriteSetLocale,
  type Locale,
} from "./paraglide/runtime";

// The design system ships its own compiled messages but delegates locale
// detection to the consuming app. Call this once at the app entrypoint so the
// DS runtime reads/writes the same locale as the app.
export function initUiI18n(runtime: {
  getLocale: () => Locale;
  setLocale: (locale: Locale, options?: { reload?: boolean }) => void;
}): void {
  overwriteGetLocale(runtime.getLocale);
  overwriteSetLocale(runtime.setLocale);
}
